import { render, staticRenderFns } from "./policyOwner.vue?vue&type=template&id=4411af6b&"
import script from "./policyOwner.vue?vue&type=script&lang=ts&"
export * from "./policyOwner.vue?vue&type=script&lang=ts&"
import style0 from "./policyOwner.vue?vue&type=style&index=0&id=4411af6b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports